import { hexToRGB } from '../../../lib/colourUtilities';
import theme from '../../../lib/theme';
import { CardGridBlockProps } from './CardGridBlock';

const { layouts, scale, media, colors } = theme;

const flexGap = '1.5em';

export default ({
  block: { columns_per_row, apply_border_drop_shadow, half_size_cards },
}: CardGridBlockProps) => ({
  container: {},

  title: {
    margin: `0 !important`,
    padding: `0 !important`,
    fontWeight: '700',
    color: colors.tas.primary,
  },

  subtitle: {
    margin: `0 !important`,
    padding: `0 !important`,
    fontWeight: '700',
    color: colors.tas.primary,
  },

  cardGridContainer: {
    flexWrap: 'wrap',
    gap: `${flexGap}`,
    display: 'flex',
    justifyContent: 'flex-start',
    width: half_size_cards ? '50%' : '100%',
  },

  cardGridCard: {
    display: 'flex',
    flex: `0 1 100% !important`,
    // maxWidth: `100% !important`,
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
    position: 'relative',
    border: 'none !important',
    boxShadow: apply_border_drop_shadow
      ? '8px 11px 10px rgb(0 0 0 / 30%)'
      : 'none',

    [media.m.up]: {
      flex: `0 1 calc(50% - ${flexGap}) !important`,
    },

    [media.l.up]: {
      flex: `0 1 calc(100% / ${columns_per_row} - ${flexGap}) !important`,
    },
  },

  cardGridContent: {
    margin: `0 !important`,
    fontWeight: '700',
    padding: '0.5em 0 !important',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    background: hexToRGB(colors.travel360.primary, '0.8'),

    '> h6': {
      color: `${colors.white} !important`,
      margin: '0 !important',
    },
  },

  cardGridContentTop: {
    top: '1rem',
    right: '5%',
    left: '5%',
    borderRadius: '40px',
  },

  cardGridContentBottom: {
    bottom: '0',
    right: '0',
    left: '0',
  },

  cardGridMobileImage: {
    [media.m.up]: {
      display: 'none',
    },

    width: '100% !important',
    maxWidth: '100% !important',
    height: 'auto !important',
  },

  cardGridImage: {
    width: '100% !important',
    maxWidth: '100% !important',
    height: 'auto !important',

    [media.m.down]: {
      '&.hasMobileImage': {
        display: 'none',
      },
    },
  },
});
